// extracted by mini-css-extract-plugin
export default {"loadingRoot":"Loading_loadingRoot__7Febk","message":"Loading_message__bHVLO"};